/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_BLACKLIST (state, val) {
    state.blacklist = val
  },
  UPDATE_BLACKLIST (state, val) {
    state.blacklist.push(...val)
  }
}
